export const FORMS = {
    ROLES: 1,
    MENU: 2,
    TEMAS: 3,
    PERFIL: 4,
    DASHBOARD: 5,
    VERSIONES: 6,
    MARCAS_MOTOS: 7,
    ARTICULOS: 8,
    CESTA: 9,
};

export const GRIDS = {
    ROLES: { id: 0, controller: '/Roles' },
    MENUS: { id: 1, controller: '/Menu' },
    MENUS_PERMISOS: { id: 2, controller: '/MenusPermisos' },
    IDIOMAS: { id: 3, controller: '/Idiomas' },
    DASHBOARD: { id: 4, controller: '/MenuUsuarioDesk' },
    VERSIONES: { id: 5, controller: '/Versiones' },
    ALERTAS: { id: 6, controller: '/Alertas' },
    MARCAS_MOTOS: { id: 7, controller: '/MarcasMotos' },
    PERFIL: { id: 8, controller: '/Usuarios' },
    TEMAS: { id: 9, controller: '/Temas' },
    CESTA: { id: 10, controller: '/Cesta' },
};

export const AYUDAS = {
    TEMAS: {
        grid: GRIDS.TEMAS,
        Component: () => import('../ayudas/Temas'),
    },
    IDIOMAS: {
        grid: GRIDS.IDIOMAS,
        Component: () => import('../ayudas/Idiomas'),
    },
};

export const FICHAS = {
    DASHBOARD: {
        Ficha: () => import('../fichas/DashboardDrawer'),
    },
    MARCAS_MOTOS: {
        Ficha: () => import('../consultas/Motos'),
        Consulta: () => import('../consultas/Motos'),
    },
    ADD_ARTICULO_CESTA: {
        Ficha: () => import('../fichas/cesta/AnyadirArticulo'),
    },
    STOCK_ALMACENES: {
        Consulta: () => import('../fichas/articulos/StockAlmacenes'),
    },
    ARTICULOS_OEM: {
        Ficha: () => import('../fichas/articulos/ArticulosOEM'),
    },
    ARTICULOS_EQUIV: {
        Ficha: () => import('../fichas/articulos/ArticulosEquivalentes'),
    },
    ESCALADO_PRECIOS: {
        Consulta: () => import('../fichas/articulos/EscaladoPrecios'),
    },
    CESTA: {
        Ficha: () => import('../fichas/cesta/Cesta'),
    },
    MI_CONFIGURACION: {
        Ficha: () => import('../fichas/perfil/usuarios/MiConfiguracion'),
    },
    REPORT_BUG: {
        Ficha: () => import('../fichas/mail/ReportBug'),
    },
    HISTORIAL: {
        Consulta: () => import('../consultas/Historial'),
    },
    CLIENTES: {
        Consulta: () => import('../consultas/Clientes'),
    },
    CENTROS: {
        Consulta: () => import('../consultas/Centros'),
    },
    FORMATO_LIBRE: {
        Ficha: () => import('../fichas/cesta/FormatoLibre'),
    },
    PEDIDO_WEB: {
        Ficha: () => import('../fichas/cesta/PedidoWeb'),
    },
    EDITAR_ARTICULO: {
        Ficha: () => import('../fichas/cesta/EditarArticulo'),
    },
};

export const REMOTE = {};

export const ICONOS = {
    DOC: 'ms-Icon ms-Icon--WordDocument icon-lg2',
    XLS: 'ms-Icon ms-Icon--ExcelDocument icon-lg2',
    PDF: 'ms-Icon ms-Icon--PDF icon-lg2',
    ZIP: 'fa fa-file-archive-o',
    WMV: 'fa fa-film',
    JPG: 'ms-Icon ms-Icon--FileImage icon-lg2',
    XLSX: 'ms-Icon ms-Icon--ExcelDocument icon-lg2',
    PPS: 'ms-Icon ms-Icon--PowerPointDocument icon-lg2',
    PPTX: 'ms-Icon ms-Icon--PowerPointDocument icon-lg2',
    DOCX: 'ms-Icon ms-Icon--WordDocument icon-lg2',
    TXT: 'ms-Icon ms-Icon--WordDocument icon-lg2',
    PPT: 'ms-Icon ms-Icon--PowerPointDocument icon-lg2',
    XLSM: 'ms-Icon ms-Icon--ExcelDocument icon-lg2',
    HTM: 'fa fa-file-code-o',
    MOV: 'fa fa-film',
    '3GP': 'fa fa-file-o',
    PNG: 'ms-Icon ms-Icon--FileImage icon-lg2',
    RTF: 'ms-Icon ms-Icon--WordDocument icon-lg2',
    CSV: 'ms-Icon ms-Icon--ExcelLogo icon-lg2',
};

export const EXTENSIONES_BYTES = [
    'jpg',
    'jpeg',
    'gif',
    'png',
    'bmp',
    'ico',
    'svg',
    'pdf',
];

export const MOTOSCAT_VIEW = {
    MOTOS: 1,
    REFERENCIA: 2,
};

export const HISTORICO_MOTOSCAT = {
    REFERENCIA: 1,
    MOTOS: 2,
};

export const ORDEN = {
    STOCK: 1,
    PRECIO: 2,
    MARCA: 3,
    REFERENCIA: 4,
    NETO: 5,
    GRUPO_MONTAJE: 6,
};

export const ACCIONES_CESTA = {
    ADD: 0,
    ELIMINAR_LINEA: 1,
    ELIMINAR_CESTA_CLIENTE: 2,
    MODIFICAR_LINEA: 3,
};
